import { type RouteObject, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { createPath } from 'utils/paths'
import { Layout } from 'ui/Layout/Layout'
import { AuthRequired } from 'features/auth/AuthRequired'

import { AdminSoftwarePage } from './software-page/AdminSoftwarePage'
import { AdminSoftwareListPage } from './software-list/AdminSoftwareListPage'
import { AdminCategoriesPage } from './categories-page/AdminCategoriesPage'

const ADMIN_PREFIX = '/admin'

export const AdminIndexPath = createPath(`${ADMIN_PREFIX}/`, <AdminIndex />)
export const AdminSoftwareListPath = createPath(`${ADMIN_PREFIX}/software-list/:status?/`, <AdminSoftwareListPage />)
export const AdminSofwarePagePath = createPath(`${ADMIN_PREFIX}/software/:softwareId/`, <AdminSoftwarePage />)
export const AdminCategoriesPagePath = createPath(`${ADMIN_PREFIX}/categories/`, <AdminCategoriesPage />)

export const AdminRoute: RouteObject = {
  path: `${ADMIN_PREFIX}/`,
  element: (
    <AuthRequired>
      <Layout showSidebar={false} />
    </AuthRequired>
  ),
  children: [AdminIndexPath, AdminSoftwareListPath, AdminSofwarePagePath, AdminCategoriesPagePath],
}

function AdminIndex() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate(AdminSoftwareListPath())
  }, [navigate])
  return null
}
